import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { API } from '../lib/api';

export default function ShortRedirect() {
  const { slug } = useParams();
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API}/s/${encodeURIComponent(slug)}?json=true`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((d) => { if (!cancelled && d && d.url) window.location.replace(d.url); })
      .catch(() => { if (!cancelled) setNotFound(true); });
    return () => { cancelled = true; };
  }, [slug]);

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#0F0A0A', color: '#fff', fontFamily: 'sans-serif', textAlign: 'center', padding: 24 }}>
      {notFound ? (
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, marginBottom: 8 }}>Link tidak ditemukan</div>
          <a href="/" style={{ color: '#F5C518' }}>Kembali ke beranda</a>
        </div>
      ) : (
        <div style={{ opacity: 0.7 }}>Mengalihkan…</div>
      )}
    </div>
  );
}
